import { TransportBlockApiResponse } from '../../Shared/Old/Layout/types';
import { TransportBlockProps } from '../../../Models/Content/TransportBlockData';
import { Typography, Icon, ArrowRightIcon } from '@norges-domstoler/dds-components';
import { HyphenateTitleElement } from '../../../Components/Shared/renderTitle';
import { useState, useEffect, ReactNode } from 'react';
import '../ListOfLinksBlock/ListOfLinksBlock.scss';
import axios from 'axios';
import NavigationCard from '../../Shared/Link/NavigationCard';

export const TransportBlock = (props: TransportBlockProps) => {
    const [buttonList, setButtonList] = useState<ReactNode[]>([]);

    useEffect(() => {
        let isCancelled: boolean = false;
        const api_url = '/api/episerver/v3/transport';
        const body = {
            url: props.path,
            currentBlockGuid: props.data.contentLink.guidValue,
            language: props?.data?.language?.name,
        };

        axios.post<TransportBlockApiResponse[]>(api_url, body).then((childrenList) => {
            if (isCancelled) return;
            if (childrenList && childrenList?.data != null && childrenList?.data.length > 0) {
                const tempList = childrenList.data.map((element: TransportBlockApiResponse) => {
                    return (
                        <NavigationCard
                            className="card-element white"
                            key={element.Link}
                            appearance="border"
                            href={element.Link}
                        >
                            <div className="card-element-container">
                                <div className="card-heading">
                                    <Typography className="hyphenate-title" typographyType="bodyShortLarge" as="p">
                                        <HyphenateTitleElement title={element.Name} />
                                    </Typography>
                                </div>
                                <Icon className="card-icon" iconSize="medium" icon={ArrowRightIcon} />
                            </div>
                        </NavigationCard>
                    );
                });
                setButtonList(tempList);
            }
        });
        return () => {
            isCancelled = true;
        };
    }, [props.data?.language?.name]);

    return (
        buttonList.length > 0 && (
            <div className="list-of-links-block-element blue">
                <div className="py-5 my-5">
                    <div className="row">
                        <div className="list-of-links-mobile col-12 col-md-12">
                            {props.data?.listDescription?.value != '' && (
                                <Typography className="my-3 me-4 hyphenate-title" typographyType="headingLarge" as="h2">
                                    <HyphenateTitleElement title={props.data?.listDescription?.value} />
                                </Typography>
                            )}
                            <div className="list-of-links-cards-list">{buttonList}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default TransportBlock;
